import { render } from "./fundDetails.vue?vue&type=template&id=f53a3a96&scoped=true"
import script from "./fundDetails.vue?vue&type=script&lang=js"
export * from "./fundDetails.vue?vue&type=script&lang=js"

import "./fundDetails.vue?vue&type=style&index=0&id=f53a3a96&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53a3a96"]])

export default __exports__